module.exports = __webpack_public_path__ + "static/media/Credits_Title.0789737b.png";